import { getCookie } from '../../common/utils/cookies';
import axios from '../../common/utils/interceptor';
import { apiUrls } from '../../constants';
import {
  VideoFeedbackStatus,
  VIDEO_FEEDBACK_POLL_DURATION,
  VIDEO_FEEDBACK_POLL_END_DURATION,
} from '../../constants/candidateFeedback';
import { SessionStore } from '../../constants/sessionStore';
import { useBasicDetails } from '../../store';

export const getVideoFeedbackStatus = (cfcId: number): void => {
  const workflowSession = sessionStorage.getItem(SessionStore.workflowSession);
  let apiPollingTimeout = 0;
  const config = {
    projectId: 0,
    storyboardConfigId: 0,
    singleUseLinkId: 0,
    reDefinitionId: 0,
    previewId: '',
    preview: false,
  };
  if (workflowSession) {
    const parsedWorkflowSession = JSON.parse(workflowSession);
    config.storyboardConfigId = cfcId;
    config.projectId = parsedWorkflowSession.projectId;
    config.singleUseLinkId = parsedWorkflowSession.singleUseLinkId;
  }
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${getCookie('token')}`,
  };

  const videoFeedbackIntervalId = setInterval(async () => {
    apiPollingTimeout = apiPollingTimeout + VIDEO_FEEDBACK_POLL_DURATION;
    if (apiPollingTimeout >= VIDEO_FEEDBACK_POLL_END_DURATION && videoFeedbackIntervalId) {
      clearInterval(videoFeedbackIntervalId);
    }

    const { data } = await axios.post(apiUrls.POST_VIDEO_FEEDBACK, config, { headers });
    if (data && data.status === VideoFeedbackStatus.AVAILABLE) {
      clearInterval(videoFeedbackIntervalId);
      sessionStorage.setItem(SessionStore.videoFeedback, JSON.stringify(data));
    }
    if (data && data.status === VideoFeedbackStatus.GENERATION_ERROR) {
      clearInterval(videoFeedbackIntervalId);
      // Update feedbackPage enabled flag to false to prevent redirection to feedback page
      const currentWorkflowItem = sessionStorage.getItem(SessionStore.currentWorkflowItem);
      if (currentWorkflowItem) {
        const workflowItemConfig = JSON.parse(JSON.parse(currentWorkflowItem).configuration);
        const updatedCurrentWorkflowItem = {
          ...useBasicDetails().currentWorkflowItem,
          configuration: JSON.stringify({
            ...workflowItemConfig,
            configWidgetJSON: {
              ...workflowItemConfig.configWidgetJSON,
              feedbackPage: { ...workflowItemConfig.configWidgetJSON.feedbackPage, enabled: false },
            },
          }),
        };
        sessionStorage.setItem(SessionStore.currentWorkflowItem, JSON.stringify(updatedCurrentWorkflowItem));
      }
    }
  }, VIDEO_FEEDBACK_POLL_DURATION);
};
